import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../shared/components/Button';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageContainer } from '../../../shared/components/PageContainer';
import { Textarea } from '../../../shared/components/Textarea';
import { useToast } from '../../../shared/components/Toast';
import { mensagemDeErro } from '../api';
import { MyTask } from '../api/desligamento';
import { formatDate } from '../components/format';
import { PessoasModal } from '../components/PessoasModal';
import { useAgirNaTarefa, useMinhasTarefas } from '../hooks/desligamento';

/** Tarefas de desligamento atribuídas ao usuário (TI, financeiro, gestor...). */
export default function MinhasTarefasDesligamentoPage() {
  const toast = useToast();
  const tarefas = useMinhasTarefas();
  const agir = useAgirNaTarefa();
  const [state, setState] = useState<{ task: MyTask; action: 'concluir' | 'dispensar' } | null>(null);
  const [notes, setNotes] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    if (!state) return;
    if (state.action === 'dispensar' && !notes.trim()) return setError('Dispensar exige justificativa.');
    try {
      await agir.mutateAsync({ id: state.task.id, action: state.action, notes: notes.trim() || undefined });
      setState(null);
      toast.success(state.action === 'concluir' ? 'Tarefa concluída.' : 'Tarefa dispensada.');
    } catch (err) {
      setError(mensagemDeErro(err, 'Não foi possível registrar a tarefa.'));
    }
  }

  const lista = tarefas.data ?? [];
  return (
    <PageContainer title="Minhas tarefas de desligamento" breadcrumbs={[{ label: 'Pessoas' }, { label: 'Minhas tarefas de desligamento' }]}>
      {lista.length === 0 ? (
        <EmptyState title="Nenhuma tarefa pendente" />
      ) : (
        <ul className="divide-y divide-gray-100 rounded-lg border border-gray-200 bg-white">
          {lista.map((t) => (
            <li key={t.id} className="flex flex-wrap items-center justify-between gap-2 px-4 py-3 text-sm">
              <div>
                <p className="font-medium text-gray-900">{t.area}: {t.title}{!t.required && <span className="text-xs text-gray-500"> (opcional)</span>}</p>
                <p className="text-gray-600">
                  <Link className="text-blue-700 hover:underline" to={`/pessoas/colaboradores/${t.userId}`}>{t.personName}</Link>
                  {' '}· matrícula {t.internalRegistration} · desligamento em {formatDate(t.terminationDate)}
                </p>
              </div>
              <span className="flex gap-2">
                <Button size="sm" onClick={() => { setNotes(''); setError(null); setState({ task: t, action: 'concluir' }); }}>Concluir</Button>
                <Button size="sm" variant="ghost" onClick={() => { setNotes(''); setError(null); setState({ task: t, action: 'dispensar' }); }}>Dispensar</Button>
              </span>
            </li>
          ))}
        </ul>
      )}
      <PessoasModal open={state !== null} title={state?.action === 'concluir' ? 'Concluir tarefa' : 'Dispensar tarefa'}
        submitLabel="Confirmar" isSubmitting={agir.isPending} submitError={error} onClose={() => setState(null)} onSubmit={submit}>
        <Textarea label={state?.action === 'dispensar' ? 'Justificativa' : 'Observação (opcional)'} value={notes} onChange={(e) => setNotes(e.target.value)} />
      </PessoasModal>
    </PageContainer>
  );
}
